import { useContext, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router';
import { makeStyles } from '@mui/styles';
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography
} from '@mui/material';

import { PATH_APP } from '@/routes/paths';
import { TerminalStatusIcon } from '../../../common/icons/TerminalStatusIcon';
import { NavStyles } from '.';
import { TerminalContext } from '../../../context/TerminalContext';
import AuthUserStore from '@/common/utils/AuthUser';

const useStyles = makeStyles(theme => ({
  terminalButton: {
    width: '100%',
    height: 64,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    },
    '&.active': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    }
  },
  terminalStatusIcon: {
    position: 'absolute',
    top: -5,
    left: 20,
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: theme.palette.error[600],
    '&.connected': {
      backgroundColor: '#3AD337'
    }
  },
  terminalHeaderText: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '12px',
    color: '#000000',
    marginTop: '4px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  terminalStatusText: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.error[600],
    '&.connected': {
      color: '#3AD337'
    }
  }
}));

const TerminalStatus = props => {
  const { isOpen, getActiveTag } = props;
  const classes = useStyles();
  const navClasses = NavStyles();
  const { serverSideReaderID } = useContext(TerminalContext);
  const [terminalConnected, setTerminalConnected] =
    useState(!!serverSideReaderID);

  useEffect(() => {
    const readerStudio = localStorage.getItem('READER_STUDIO');
    setTerminalConnected(
      !!serverSideReaderID && readerStudio == AuthUserStore.getStoreCode()
    );
  }, [serverSideReaderID]);

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        component={RouterLink}
        className={`${classes.terminalButton} ${getActiveTag(
          PATH_APP.terminals.root,
          location.pathname
        )}`}
        to={PATH_APP.terminals.root}
        sx={{
          justifyContent: isOpen ? 'initial' : 'center'
        }}
      >
        {isOpen && (
          <Box>
            <Typography className={classes.terminalHeaderText}>
              Terminal status
            </Typography>
            <Typography
              className={`${classes.terminalStatusText} ${
                terminalConnected ? 'connected' : ''
              }`}
            >
              {terminalConnected ? 'Connected' : 'Disconnected'}
            </Typography>
          </Box>
        )}
        <ListItemIcon
          className={`${navClasses.linkIcon} terminalStatus`}
          sx={{ mr: isOpen ? 2 : 'auto' }}
        >
          <TerminalStatusIcon />
          <div
            data-testid="terminal-status-badge"
            className={`${classes.terminalStatusIcon} ${
              terminalConnected ? 'connected' : ''
            }`}
          ></div>
        </ListItemIcon>
      </ListItemButton>
    </ListItem>
  );
};

export default TerminalStatus;
